import { Flex, Table } from "antd";
import React from "react";
import { getOutstandingContractorQuotesColumns } from "projects/constants";
import variables from "../../../_variables.scss";
import "./OutstandingContractorQuotes.scss";
import { IOutstandingContractorQuote } from "projects/models";
import { useBoundStore } from "store";

interface OutstandingContractorQuotesProps {
  outstandingContractorQuotes: IOutstandingContractorQuote[];
}

export const OutstandingContractorQuotes = ({ outstandingContractorQuotes }: OutstandingContractorQuotesProps) => {
  const { currentOrganization } = useBoundStore();
  const tblRef: Parameters<typeof Table>[0]["ref"] = React.useRef(null);
  const tableColumns = getOutstandingContractorQuotesColumns(currentOrganization);

  return (
    <Flex
      vertical
      gap={variables.gap}
      data-testid='outstandingContractorQuotes'
    >
      <h2>Outstanding Contractor Quotes ({">"} 2 weeks)</h2>
      <Table
        columns={tableColumns}
        dataSource={outstandingContractorQuotes}
        className='outstanding-contractor-quotes-table'
        ref={tblRef}
        rowKey='id'
        pagination={false}
        scroll={{ y: variables.defaultComponentHeight }}
      />
    </Flex>
  );
};
